'use client';

import parse from 'html-react-parser';

import { P } from '@/components/atoms/Typography/P';

import type { ItemDataType } from '../OrderedItemsSection.types';

interface OrderedItemsListProps {
    itemList: ItemDataType[];
}

const OrderedItemsList = ({ itemList }: OrderedItemsListProps) => (
    <ol className="flex flex-wrap justify-center">
        {itemList?.map(({ title, number, text }) => (
            <li
                key={number}
                className="mb-8 flex w-full flex-row-reverse items-center gap-x-8 md:mb-4 md:w-1/2 md:flex-row"
            >
                <span className="absolute z-[-1] min-w-[60px] font-secondary text-[132px] font-extrabold leading-none text-grey-100 dark:text-grey-600 md:relative md:z-auto">
                    {number}
                </span>

                <div className="z-20 w-full md:pr-4">
                    <P className="mb-4 text-3xs font-bold uppercase">{title}</P>

                    <P>{parse(text)}</P>
                </div>
            </li>
        ))}
    </ol>
);

export default OrderedItemsList;
